import LinkButton from "ds/components/Button/LinkButton";
import Callout from "ds/components/Callout";
import FeedbackActions from "ds/components/Feedback/Actions";
import Link from "ds/components/Link";
import { getDocsUrl } from "utils/getDocsUrl";

const IntentProjectAgreementBanner = () => {
  return (
    <Callout variant="info" storageKey="intent-project-agreement-banner">
      By using Spacelift Intent, you agree to our{" "}
      <Link href={getDocsUrl("/legal/intent-terms")} target="_blank">
        Terms of Service
      </Link>
      .
      <FeedbackActions>
        <LinkButton
          variant="secondary"
          size="small"
          href={getDocsUrl("/concepts/intelligence/intent")}
          target="_blank"
        >
          Learn more
        </LinkButton>
      </FeedbackActions>
    </Callout>
  );
};

export default IntentProjectAgreementBanner;
